export default __webpack_public_path__ + "static/muli-v20-latin-700-32240ca19f553b9efc06acdbff8a17ec.woff2";